import { render } from "./PlatformLogsFilters.vue?vue&type=template&id=747ef984&scoped=true&ts=true"
import script from "./PlatformLogsFilters.vue?vue&type=script&lang=ts"
export * from "./PlatformLogsFilters.vue?vue&type=script&lang=ts"

import "./PlatformLogsFilters.vue?vue&type=style&index=0&id=747ef984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747ef984"]])

export default __exports__